import { cn } from '../../../lib/stylingUtils';
import { ThemeColor } from '../../../types';
import { Badge, Col, IDTag } from '../../ui';

type FieldDisplayProps = {
  label: string;
  value: string | null | undefined;
  className?: string;
};

export const FieldDisplay = ({
  label,
  value,
  className,
}: FieldDisplayProps) => (
  <Col className={cn('@FieldDisplay', 'gap-0.5 py-1', className)}>
    <span className="text-xs text-neutral/50">{label}</span>
    <span className="text-sm">{value ?? 'N/A'}</span>
  </Col>
);

type IDFieldProps = {
  label: string;
  value: string | null | undefined;
  className?: string;
};

export const IDField = ({ label, value, className }: IDFieldProps) => (
  <Col className={cn('@IDField', 'gap-0.5 py-1', className)}>
    <span className="text-xs text-neutral/50">{label}</span>
    {value ? (
      <IDTag size="xs">{value}</IDTag>
    ) : (
      <span className="text-sm text-neutral/40">N/A</span>
    )}
  </Col>
);

type BadgeFieldProps = {
  label: string;
  value: string | null | undefined;
  color?: ThemeColor;
  className?: string;
};

export const BadgeField = ({
  label,
  value,
  color = 'neutral',
  className,
}: BadgeFieldProps) => (
  <Col className={cn('@BadgeField', 'gap-0.5 py-1', className)}>
    <span className="text-xs text-neutral/50">{label}</span>
    {value ? (
      <Badge color={color} size="small">
        {value}
      </Badge>
    ) : (
      <span className="text-sm text-neutral/40">N/A</span>
    )}
  </Col>
);
